import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import BusinessDetailsPage from '@/pages/business/BusinessDetailsPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: 'business',
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    displayNav: true,
  },
  children: [
    {
      path: '',
      alias: '/pay-vendors/business-profile/details',
      name: RouteNames.BUSINESS.INDEX,
      component: BusinessDetailsPage,
    },
  ],
});
